import { createStore } from '@udecode/zustood';

const redirectStore = createStore('redirect')<{ url: string | null }>(
    { url: null },
    { persist: { name: 'redirect-store', enabled: true } }
);

export default redirectStore;
